import { createContext, FC, ReactNode, useContext, useMemo, useState } from 'react';
import {
  BrokerConfig,
  BrokerSpecificComponentsProps,
  LoginModalState,
} from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import { getLocalStorage } from 'common/utils/localstorage';
import _ from 'lodash';
import { getLoginModal } from '../config';

const {
  applicationDomain: {
    config: { brokerConfigs },
  },
} = window;

type LoginContextValue = {
  state: LoginModalState;
  onPartialStateUpdate: (partialState: Partial<LoginModalState>) => void;
  brokersToShowInUi: LoginModalState['filteredBrokerLists'];
  switchPage: BrokerSpecificComponentsProps['switchPage'];
  handleLogin: (brokerConfig: BrokerConfig) => void;
};

const LoginContext = createContext<LoginContextValue | undefined>(undefined);

export const useLoginContext = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('useLoginContext must be used within a LoginProvider');
  }
  return context;
};

export const LoginProvider: FC<{ children: ReactNode }> = ({ children }) => {
  console.log(brokerConfigs, "brokerConfigsbrokerConfigs")
  const brokersToShowInUi: LoginModalState['filteredBrokerLists'] = useMemo(
    () =>
      _.chain(brokerConfigs)
        .filter((config) => config.is_show)
        .map((c) => c)
        .value(),
    []
  );

  const [state, setState] = useState<LoginModalState>({
    searchValue: '',
    filteredBrokerLists: brokersToShowInUi,
    previouslyLoggedInBrokerList: _.filter(
      brokerConfigs,
      (config: BrokerConfig) => config.id === getLocalStorage('domainOrPreviousLoggedInBrokerId')
    ),
    selectedBrokerConfig: null,
    __rawBrokerConfig: brokerConfigs,
    currentPageIndex: 0,
  });

  const onPartialStateUpdate = (partialState: Partial<LoginModalState>) => {
    setState((prevState) => ({ ...prevState, ...partialState }));
  };

  const switchPage: BrokerSpecificComponentsProps['switchPage'] = (moveForward = true) => {
    if (state.currentPageIndex === 0 && !moveForward) return;
    const updatedIndex = moveForward ? state.currentPageIndex + 1 : state.currentPageIndex - 1;
    onPartialStateUpdate({ currentPageIndex: updatedIndex });
  };

  // On Submit
  const handleLogin = (brokerConfig: BrokerConfig) => {
    console.log('handleLogin called with brokerConfig:', brokerConfig);
    if (!brokerConfig.href) {
      onPartialStateUpdate({
        selectedBrokerConfig: _.find(
          state.__rawBrokerConfig,
          (broker: BrokerConfig) => broker.id === brokerConfig.id
        ),
      });
      switchPage();
      return;
    }
    // hit the broker login phase
    getLoginModal(brokerConfig);
  };

  return (
    <LoginContext.Provider
      value={{
        state,
        onPartialStateUpdate,
        brokersToShowInUi,
        switchPage,
        handleLogin,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};
